import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';

/**
 *  Pagenation
 */
class Pagenation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string,
      external: PropTypes.bool,
      current: PropTypes.bool
    })),
    linkColor: PropTypes.string
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    links: null,
    linkColor: null
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    const {
      containerId,
      containerClass,
      anchorPoint,
      anchorName,
      links,
      linkColor
    } = this.props;

    let currentIndex, prevHref, nextHref;

    if(links && Array.isArray(links) && links.length > 0){
      for(let i = 0; i < links.length; i++){
        if(links[i].current){
          currentIndex = i;
          break;
        }
      }
    }

    if(links.length === 0){
      prevHref = '#';
      nextHref = '#';
    }
    else if(links.length === 1){
      prevHref = links[currentIndex].href;
      nextHref = links[currentIndex].href;
    }
    else{
      prevHref = currentIndex - 1 >= 0            ? links[currentIndex - 1].href : links[links.length - 1].href;
      nextHref = currentIndex + 1 < links.length ? links[currentIndex + 1].href : links[0].href;
    }
    
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
        anchorPoint={anchorPoint}
        anchorName={anchorName}
      >
        <div className='Pagenation'>
          <div 
            className={
              'Pagenation__container' + 
              ' Pagenation__container--' + linkColor + 
              (links.length >= 6 ? ' Pagenation__container--over6' : '')
            }
          >
            <div className={'Pagenation__container__arrow Pagenation__container__arrow--prev' + (currentIndex === 0 ? ' hide' : '')}>
              <a href={prevHref} className='Pagenation__container__arrow__link'>prev</a>
            </div>
            {(() => {
              if(links && Array.isArray(links) && links.length > 0){
                return(
                  <ul className='Pagenation__container__list'>
                  {
                    links.map((linkItem, index) => {
                      {
                        return(
                          <li className='Pagenation__container__list__item' key={index}>
                            <a
                              href={linkItem.href}
                              target={linkItem.external ? '_blank' : ''}
                              className={
                                'Pagenation__container__list__item__link' + 
                                (linkItem.current ? ' Pagenation__container__list__item__link--current' : '')
                              }
                            >
                              {index+1}
                            </a>
                          </li>
                        );
                      }
                    })
                  }
                  </ul>
                );
              }
            })()}
            <div className={'Pagenation__container__arrow Pagenation__container__arrow--next' + (currentIndex === links.length - 1 ? ' hide' : '')}>
              <a href={nextHref} className='Pagenation__container__arrow__link'>next</a>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
  
}

export default Pagenation;



// WEBPACK FOOTER //
// ./src/containers/pagenation/index.jsx